import { SET_CURRENT_PAGE, SET_SELECTED_CATEGORY } from "./actionTypes";

export const setCurrentPage = (page) => ({
  type: SET_CURRENT_PAGE,
  payload: page,
});

export const setSelectedCategory = (category) => ({
  type: SET_SELECTED_CATEGORY,
  payload: category,
});
